import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import './FamilyBundleInfoPopup.scss';
import checkIcon from '../images/checkIcon.svg';

function FamilyBundleInfoPopup(props) {
    const { closePopUp, packageData, info } = props;

    return (
        <div className="family-bundle-info-popup">
            <div className='popup-text'>
                <h2 className="popup-title">{packageData.titleEpi}</h2>
                <p className="popup-subtitle">{packageData.labelEpi}</p>
            </div>

            <div className="info-list">
                {info?.map((item, index) => (
                    <div key={index} className="info-item">
                        <Image src={checkIcon} alt="check" className="check-icon" />
                        <p className="info-text">{item}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default FamilyBundleInfoPopup;
